import {useTileAnimation, type TileProps} from './types'

export const Tile7 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'path',
    scaleProperty: 'scale',
    skipFirst: false,
    transformOrigin: 'center',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <rect width="400" height="403" transform="translate(0 -100.559)" fill={colors[0]} />
      <path d="M99.9117 55.2998L139.737 55.2998L139.737 14.9998L99.9117 14.9998L99.9117 55.2998Z" fill={colors[1]} />
      <path d="M259.229 55.2998L299.055 55.2998L299.055 14.9998L259.229 14.9998L259.229 55.2998Z" fill={colors[1]} />
      <path d="M20.2611 135.908L60.0864 135.908L60.0864 95.6082L20.2611 95.6082L20.2611 135.908Z" fill={colors[1]} />
      <path d="M179.57 135.908L219.395 135.908L219.395 95.6082L179.57 95.6082L179.57 135.908Z" fill={colors[1]} />
      <path d="M338.88 135.909L378.705 135.909L378.705 95.6092L338.88 95.6092L338.88 135.909Z" fill={colors[1]} />
    </svg>
  )
}
